import {$getModuleColor, $getModuleIcon} from "./appModules"
import {useAuthStore} from "~/store/auth"
import type {SidebarMenu} from "~/types/sidebarMenu"

export const sidebarMenu: SidebarMenu = [
    {
        title: 'default',
        menu: [
            {
                title: 'menu.dashboard',
                path: 'dashboard',
                icon: $getModuleIcon('dashboard'),
                module: 'dashboard',
            },
            {
                title: 'menu.customers',
                path: 'customers',
                icon: $getModuleIcon('organisations'),
                module: 'organisations',
                ability: ['viewAny', 'organisations'],
                hidden: () => !useAuthStore().userData?.is_service_provider
            },
            {
                title: 'menu.settings',
                path: 'settings',
                icon: $getModuleIcon('settings'),
                color: $getModuleColor('settings'),
                module: 'settings',
                children: [
                    {
                        title: 'menu.myOrganisation',
                        path: {
                            name: 'organisations-id-organisationBaseData',
                            params: {id: (useAuthStore().userData?.organisation_id ?? '') as string}
                        },
                        module: 'organisations',
                        icon: $getModuleIcon('organisations'),
                        ability: ['update', 'organisations']
                    },
                    {
                        title: 'menu.loginProviders',
                        path: 'settings-loginProviders',
                        ability: ['update', 'loginProviders']
                    },
                    {
                        title: 'menu.mails',
                        path: 'settings-mails',
                        ability: ['viewAny', 'mails'],
                        feature: 'mailLogs'
                    }
                ]
            },
            {
                title: 'menu.system',
                path: 'system',
                icon: $getModuleIcon('system'),
                color: $getModuleColor('system'),
                module: 'system',
                ability: ['admin', 'system'],
                children: [
                    {
                        title: 'menu.organisations',
                        path: 'organisations',
                        icon: $getModuleIcon('organisations'),
                        module: 'organisations',
                        ability: ['viewAny', 'organisations']
                    },
                    {
                        title: 'menu.containerTemplates',
                        path: 'system-containerTemplates',
                        ability: ['update', 'containerTemplates']
                    },
                    {
                        title: 'menu.mailTemplates',
                        path: 'system-mailTemplates',
                        ability: ['viewAny', 'mailTemplates']
                    },
                    {
                        title: 'menu.contractors',
                        path: 'system-contractors',
                        ability: ['viewAny', 'contractors'],
                    },
                    {
                        title: 'menu.wasteCategories',
                        path: 'system-wasteCategories',
                        ability: ['viewAny', 'wasteCategories'],
                    },
                    {
                        title: 'menu.plans',
                        path: 'system-plans',
                        ability: ['update', 'plans'],
                        feature: 'billingSystem'
                    }
                ]
            },
        ]
    }
]